import { render, staticRenderFns } from "./ChatWindowManagerTool.vue?vue&type=template&id=61843b14"
import script from "./ChatWindowManagerTool.vue?vue&type=script&lang=js"
export * from "./ChatWindowManagerTool.vue?vue&type=script&lang=js"
import style0 from "./ChatWindowManagerTool.vue?vue&type=style&index=0&id=61843b14&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports